import { Chip, Tooltip } from '@mui/material';

import { DEFAULT_DELIVER_BY_AT_RISK_THRESHOLD_MINUTES } from '../../constants/eta';

const BADGE_CONFIGS = {
  'on-time': {
    color: '#297a48',
    backgroundColor: '#b2f1c0',
    getTooltip: () => 'On track: estimated to complete before the Driver OTD time.',
  },
  'at-risk': {
    color: '#f97500',
    backgroundColor: '#ffe8d1',
    getTooltip: (thresholdMinutes) => `At risk: estimated to complete within ${thresholdMinutes} minutes before the Driver OTD time.`,
  },
  late: {
    color: '#ba1a1a',
    backgroundColor: '#ffdad6',
    getTooltip: () => 'Late: estimated to complete after the Driver OTD time.',
  },
};

export const formatDelta = (deltaSeconds) => {
  const totalMinutes = Math.floor(Math.abs(deltaSeconds) / 60);
  if (totalMinutes === 0) return '0m';

  const sign = deltaSeconds < 0 ? '-' : '+';
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${sign}${hours}h ${minutes}m` : `${sign}${minutes}m`;
};

const getBadgeStatus = (deltaSeconds, thresholdSeconds) => {
  // (59s → 0m) (15m59s → 15m) (-1m59s → -1m) 
  const deltaMinutes = Math.trunc(deltaSeconds / 60);
  const thresholdMinutes = Math.trunc(thresholdSeconds / 60);

  if (deltaMinutes > 0) {
    return 'late';
  }
  // [0m, -threshold], both at-risk (e.g: actual late 59s → 0m → at-risk)
  if (thresholdMinutes > 0 && Math.abs(deltaMinutes) <= thresholdMinutes) {
    return 'at-risk';
  }
  return 'on-time';
};

function TrackingBadge(props) {
  const { targetTime, actualTime, threshold } = props;

  if (!Number.isFinite(targetTime) || !Number.isFinite(actualTime)) return null;

  // Timestamps are ms, threshold is seconds
  const thresholdSeconds = Number.isFinite(threshold) ? threshold : DEFAULT_DELIVER_BY_AT_RISK_THRESHOLD_MINUTES * 60;
  const deltaSeconds = (actualTime - targetTime) / 1000;
  const status = getBadgeStatus(deltaSeconds, thresholdSeconds);
  const { getTooltip, ...badgeColors } = BADGE_CONFIGS[status];
  return (
    <Tooltip title={getTooltip(Math.floor(thresholdSeconds / 60))} arrow placement='top'>
    <Chip
      size="small"
      sx={{
        ...badgeColors,
        fontSize: '9px',
        height: '18px',
        '& .MuiChip-label': { px: '6px' },
      }}
      label={formatDelta(deltaSeconds)}
    />
    </Tooltip>
  );
}

export default TrackingBadge;
